<simulations-add-edit-layout
    [farms]="farms"
    [lots]="globalRegistry?.systemData?.lots"
    [simulationId]="simulationId"
    (submitSimulation)="submitSimulation($event)"
    (updateSimulation)="updateSimulation($event)"
    (deleteSimulation)="deleteSimulation($event)"
>
</simulations-add-edit-layout>